import React, { useCallback, useEffect, useState } from 'react';
import { Truck } from 'lucide-react';
import { PayablesTab, ReturnsTab } from './PayablesTab';
import { PartsTab } from './PartsTab';
import { PosTab } from './PosTab';
import { VendorsTab } from './VendorsTab';
import { PriceCompareTab } from './PriceCompareTab';
import { useApi } from './ui';

const TABS = [['vendors', 'Vendors'], ['pos', 'Purchase orders'], ['parts', 'Parts & reorder'], ['compare', 'Price compare'], ['owe', 'What you owe'], ['returns', 'Returns']];

export default function PurchasingPage() {
  const { call } = useApi();
  const [tab, setTab] = useState('pos');
  const [d, setD] = useState({ vendors: [], items: [], pos: [], board: null, returns: [] });
  const load = useCallback(async () => {
    const [vendors, items, pos, board, returns] = await Promise.all(['/purchasing/vendors', '/purchasing/items', '/purchasing/pos', '/purchasing/payables', '/purchasing/returns'].map((p) => call('get', p)));
    setD({ vendors, items, pos, board, returns });
  }, [call]);
  useEffect(() => { load().catch(() => {}); }, [load]);
  return (
    <div className="min-h-full space-y-5 bg-slate-50 p-4 sm:p-6" data-testid="purchasing-page">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-100 text-teal-700"><Truck size={20} /></span>
        <div><h1 className="text-2xl font-bold text-slate-900">Vendor Management</h1><p className="text-sm text-slate-500">Purchase orders, stock-in, vendor bills and returns, tied to Inventory.</p></div>
      </div>
      <div className="flex gap-1 overflow-x-auto border-b">
        {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`whitespace-nowrap border-b-2 px-4 py-2 text-sm font-semibold ${tab === k ? 'border-teal-600 text-teal-700' : 'border-transparent text-slate-500'}`} data-testid={`purch-tab-${k}`}>{l}</button>)}
      </div>
      {tab === 'vendors' && <VendorsTab vendors={d.vendors} items={d.items} reload={load} />}
      {tab === 'pos' && <PosTab pos={d.pos} vendors={d.vendors} items={d.items} reload={load} />}
      {tab === 'parts' && <PartsTab items={d.items} vendors={d.vendors} reload={load} />}
      {tab === 'compare' && <PriceCompareTab vendors={d.vendors} reload={load} />}
      {tab === 'owe' && <PayablesTab board={d.board} vendors={d.vendors} items={d.items} reload={load} />}
      {tab === 'returns' && <ReturnsTab returns={d.returns} />}
    </div>
  );
}
